
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {STATUS} from './status.model';
import {DesignService} from '../design/design.service';
import { SESSION_STORAGE } from 'src/app/project/pages/identification/identification.model';

@Injectable({
   providedIn: 'root'
})
export class StatusService {

   private statusSource_: BehaviorSubject<STATUS> = new BehaviorSubject<STATUS>(STATUS.NONE);
   private consentId_: string = "-1";
   public status$: Observable<STATUS> = this.statusSource_.asObservable();
   private agreementUrl_: string = '';
   private delayTimeRedirect_: number = 2000;
   private target_: string = "";
   public STATUS: typeof STATUS = STATUS;

   set status (status: STATUS) {
      this.statusSource_.next(status);
   }

   get consentId (): string {
      return this.consentId_;
   }

   set consentId (id: string) {
      this.consentId_ = id;
   }

   public setAgreementUrl (url: string) {
      this.agreementUrl_ = this.consentId && this.consentId.startsWith('http') ? this.consentId : `${url}?uuid=${this.consentId}${sessionStorage.getItem(SESSION_STORAGE.CONSULTANTUUID) ? '&consultant=' + sessionStorage.getItem(SESSION_STORAGE.CONSULTANTUUID) : ''}`;
   }

   get agreementUrl (): string {
      return this.agreementUrl_;
   }

   set delayTimeRedirect (newValue: number) {
      this.delayTimeRedirect_ = newValue ?? 2000;
   }

   get delayTimeRedirect (): number {
      return this.delayTimeRedirect_;
   }

   set target (value: string) {
      this.target_ = value ?? "_blank";
   }

   get target (): string {
      return this.target_;
   }

   constructor (public sDesign: DesignService) { }

   public reset (): void {
      this.statusSource_.next(STATUS.NONE);
      this.consentId_ = "-1";
      this.agreementUrl_ = '';
      this.delayTimeRedirect_ = 2000;
      this.target_ = "";
      this.status = STATUS.NONE;
   }
}
